import * as RadixSlider from "@radix-ui/react-slider";
import styles from "./Slider.module.scss";
import { Label } from "../Label/Label";

interface IProps {
    handleChange: (value: number) => void;
    name: string;
    id: string;
    value: number;
    label: string;
    min: number;
    max: number;
}

export const Slider = (props: IProps) => {
    return (
        <div className={`${styles.wrapper}`}>
            <Label htmlFor={props.id} className={styles.label}>
                {props.label}
            </Label>
            <RadixSlider.Root
                className={styles.Root}
                onValueChange={(values) => props.handleChange(values[0])}
                value={[props.value]}
                min={props.min}
                max={props.max}
                step={1}
            >
                <RadixSlider.Track className={styles.Track}>
                    <RadixSlider.Range className={styles.Range} />
                </RadixSlider.Track>
                <RadixSlider.Thumb className={styles.Thumb} aria-label="Volume" />
            </RadixSlider.Root>
        </div>
    );
};
